// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"957":"a23efd5b","990":"e62aebbd"}[chunkId] + ".chunk.css";
};